import PropTypes from 'prop-types';
import { useState } from 'react';

import { CtaPropTypes } from '@/constants/propTypes';
import MillesimaLink from './MillesimaLink';

export const LinkButton = ({ cta, isNofollow, withBorder = false }) => {
  const [hover, setHover] = useState(false);

  const { url, text, background } = cta;

  const styles = {
    color: hover ? text.hoverColor : text.color,
    background: hover ? background.hoverColor : background.color,
    border: !withBorder && 'none'
  };

  return (
    <MillesimaLink href={url} ariaLabel={text.label} isNofollow={cta.isNofollow || isNofollow} isWithoutContainer>
      <button
        data-test-id="button"
        className="btn btn-black"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={styles}
        type="submit"
      >
        {text.label}
      </button>
    </MillesimaLink>
  );
};

LinkButton.propTypes = {
  cta: PropTypes.shape(CtaPropTypes).isRequired,
  isNofollow: PropTypes.bool,
  withBorder: PropTypes.bool
};

export default LinkButton;
